module.exports = __webpack_public_path__ + "static/media/blueClinic.3e544b14.svg";